import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { getSchoolUserCountQuery } from "../modules/CoursesQueries";
import { getSelectedAcademicYearIdForSchool } from "MyCalendar/modules/Utils";
import _ from "lodash";
import useReduxState from "Hooks/useReduxState";

/**
 * Fetches participant counts for a single school (curriculum program).
 * Designed to be called inside SchoolHeader so each school fetches independently.
 *
 * @param {Object} params
 * @param {string} params.organizationId
 * @param {string} params.schoolId
 * @param {boolean} params.skip - Skip fetching (e.g. viewOnly mode)
 * @returns {{ counts: { staffCount, studentCount, familyCount, totalCount } | null, loading: boolean }}
 */
const useSchoolCounts = ({ organizationId, schoolId, skip }) => {
  const academicYearId = useReduxState(getSelectedAcademicYearIdForSchool);
  const { data, loading } = useQuery(getSchoolUserCountQuery, {
    variables: {
      organizationId,
      input: {
        entity: "CURRICULUM_PROGRAM",
        entityIds: [schoolId],
        academicYearId,
      },
    },
    context: { useHttpLink: true },
    skip: skip || !schoolId || !organizationId,
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  const counts = useMemo(
    () => _.get(data, "node.users.userCountByEntity", null),
    [data]
  );

  return { counts, loading };
};

export default useSchoolCounts;
